export const Wallet = `<svg width="32" height="32" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M27 21.6V25C27 26.1046 26.1046 27 25 27H5C3.89543 27 3 26.1046 3 25V9H25C26.1046 9 27 9.89543 27 11V14.4" stroke="currentColor" stroke-width="2"/>
<path d="M3 15V6C3 5.44772 3.44772 5 4 5H13H22.5C22.7761 5 23 5.22386 23 5.5V9.54545" stroke="currentColor" stroke-width="2"/>
<rect x="19" y="15" width="10" height="6" rx="1" stroke="currentColor" stroke-width="2"/>
</svg>`;
